module.exports = __webpack_public_path__ + "static/media/renewal.c4f35bbf.svg";